import { isNil } from './validation';

export function formatNumber(
  value: number,
  options: Intl.NumberFormatOptions = { minimumFractionDigits: 2, maximumFractionDigits: 2 }
): string {
  return new Intl.NumberFormat('pt-br', options).format(value);
}

export function formatIntNumber(value: number, separator = '.') {
  return value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
}

export function formatCurrencyNumber(value?: number) {
  return !isNil(value) ? formatNumber(value ?? 0, { style: 'currency', currency: 'BRL' }) : '';
}

export function formatEightDecimalsNumber(value: number): string {
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 8,
    maximumFractionDigits: 8,
  }).format(value);
}

export function formatEightDecimalsCurrency(value: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 8,
    maximumFractionDigits: 8,
  }).format(value);
}
